'use client';

import {Box, styled} from '@mui/material';

export const StyledCtaCardContainer = styled(Box)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(2),
}));


export const StyledCtaCardRoot = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadiusMd,
  paddingBottom: '56.25%' /* 16:9 */,
  cursor: 'pointer',
  height: 360,
  display: 'flex',
  margin: 'auto',
  '&:hover img': {
    transform: 'scale(1.03)',
  },
  '& img': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
    transition: 'transform 400ms ease',
  },
  // content container holds heading and bread anchored to bottom-left
  '& .content': {
    top: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.25),
    // Use a pseudo-element for the gradient so child content (heading) stays visible.
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 3,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 50%)',
      opacity: 1,
      pointerEvents: 'none',
      zIndex: 1,
    },
  },
  '& .heading': {
    position: 'relative',
    color: theme.palette.common.white,
    zIndex: 20
  },
  '& .content .bread': {
    position: 'relative',
    color: theme.palette.common.white,
    overflow: 'hidden',
    transition: 'opacity 300ms cubic-bezier(0.4, 0, 0.2, 1), max-height 300ms cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    maxHeight: 0,
    opacity: 0,
    zIndex: 20,
    marginBottom: theme.spacing(0),
  },
  '&.no-gradient .content::before': {
    display: 'none',
  },
  // reveal the bread text on hover when bread exists
  '&.has-bread:hover .content .bread': {
    maxHeight: 240,
    opacity: 1,
    marginBottom: theme.spacing(0.5),
  },

  // ---- v2 variant: image on top, white panel below with always-visible
  // heading + read-more, bread reveals on hover and steals height from the image.
  '&[data-variant="v2"]': {
    flexDirection: 'column',
    paddingBottom: 0,
  },
  '&[data-variant="v2"] .media': {
    position: 'relative',
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'hidden',
  },
  '&[data-variant="v2"] .panel': {
    position: 'relative',
    flex: '0 0 auto',
    backgroundColor: theme.palette.background.white,
    color: theme.palette.text.dark,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  '&[data-variant="v2"] .panel .heading': {
    position: 'static',
    color: theme.palette.text.dark,
  },
  '&[data-variant="v2"] .panel .bread': {
    position: 'static',
    color: theme.palette.text.dark,
    maxHeight: 0,
    opacity: 0,
    overflow: 'hidden',
    margin: 0,
    transition: 'opacity 300ms cubic-bezier(0.4, 0, 0.2, 1), max-height 300ms cubic-bezier(0.4, 0, 0.2, 1), margin 300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  '&[data-variant="v2"].has-bread:hover .panel .bread': {
    maxHeight: 240,
    opacity: 1,
    marginTop: theme.spacing(0.5),
  },
  '&[data-variant="v2"] .read-more': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    color: theme.palette.text.link,
    fontWeight: 600,
  },
}));

export const StyledCtaCardArrowContainer = styled(Box)(({theme}) => ({
  position: 'absolute',
  right: theme.spacing(0.5),
  bottom: theme.spacing(0.25),
  width: 36,
  height: 36,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 30,
  // don't block clicks on the card
  pointerEvents: 'none',
}));